import Financial from '../../Components/Financial';

function Dashboard(){
    return(
        <Financial/>
    )
};

export default Dashboard;